import {
    GETKYCCONFIGURATIONID_SUCCESS,
    GETKYCCONFIGURATIONID_FAILED,
    RESET_GETKYCCONFIGURATIONID,
    LOADING_GETKYCCONFIGURATIONID,
    NETWORK_ERROR_GETKYCCONFIGURATIONID,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetKycConfigurationId = () => {
    return { type: RESET_GETKYCCONFIGURATIONID };
};

const getKycConfigurationId = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETKYCCONFIGURATIONID });
    await partnerServices
        .post("getKycConfigurationIds", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getKycConfigurationIdsuccess(res.data));
                    break;
                default:
                    dispatch(getKycConfigurationIdFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETKYCCONFIGURATIONID, payload: err });
        });
};
function getKycConfigurationIdsuccess(data) {
    return {
        type: GETKYCCONFIGURATIONID_SUCCESS,
        payload: data,
    };
}
function getKycConfigurationIdFailed(data) {
    return {
        type: GETKYCCONFIGURATIONID_FAILED,
        payload: data,
    };
}

export { resetGetKycConfigurationId, getKycConfigurationId };
